<template>
<div id="service-msg" v-if="messages.length">
  <div v-for="msg in openedMessages" :key="msg.text" class="msg-item">
    {{ msg.text }}
    <a class="close" @click.stop.prevent="close(msg)">×</a>
  </div>
</div>
</template>

<script>
import MessageRepository from '@/repositories/MessageRepository.js'

export default {
  name: 'ServiceMessage',
  data () {
    return {
      messages: [],
      fetchInterval: null,
    }
  },

  mounted () {
    this.fetchMessages()
    this.fetchInterval = setInterval(this.fetchMessages.bind(this), 30000)
  },

  computed: {
    openedMessages () {
      return this.messages.filter((m) => !m.closed)
    }
  },

  methods: {
    fetchMessages () {
      if (this.$store.state.authenticated) {
        MessageRepository.fetchServiceMessages().then(
          (messages) => {
            // add new arrived messages
            for (const message of messages) {
              if (this.messages.find((m) => m.text === message)) continue
              this.messages.push({ text: message, closed: false })
            }
            // remove stale messages
            for (const m of this.messages) {
              if (messages.find((message) => message === m.text)) continue
              console.log('remvoe', m.text)
              this.messages = this.messages.filter((msg) => msg.text !== m.text)
            }
          },
          (error) => {
            console.log('errr', error)
            clearInterval(this.fetchInterval)
          }
        )
      }
    },
    close (message) {
      message.closed = true
    }
  }
}
</script>

